import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

function StudentDetails() {

    const { id } = useParams();

    const [student, setStudent] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getStudent();
    }, []);

    const getStudent = async () => {

        try {

            const response = await axios.get(
                `http://localhost:5000/api/students/${id}`
            );

            setStudent(response.data.data);
            setLoading(false);

        } catch (error) {

            console.log(error);
            setLoading(false);

        }

    };

    const generatePDF = async () => {

        try {

            const response = await axios.post(
                "http://localhost:5000/generate-pdf",
                {
                    studentId: id
                },
                {
                    responseType: "blob"
                }
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: "application/pdf"
                })
            );

            const link = document.createElement("a");

            link.href = url;
            link.download = `${student.name}.pdf`;

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {

            console.log(error);

        }

    };

    if (loading) {
        return (
            <div className="container mt-5">
                <h4>Loading...</h4>
            </div>
        );
    }

    return (

        <div className="container-fluid mt-1">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h3>Student Details</h3>

                </div>

                <div className="card-body">

                    <table className="table table-bordered">

                        <tbody>

                            <tr>
                                <th width="200">Name</th>
                                <td>{student.name}</td>
                            </tr>

                            <tr>
                                <th>City</th>
                                <td>{student.city}</td>
                            </tr>

                            <tr>
                                <th>Phone</th>
                                <td>{student.phone}</td>
                            </tr>

                            <tr>
                                <th>Created At</th>
                                <td>
                                    {student.createdAt
                                        ? new Date(student.createdAt).toLocaleString()
                                        : ""}
                                </td>
                            </tr>

                        </tbody>

                    </table>

                    <button
                        className="btn btn-danger me-2"
                        onClick={generatePDF}
                    >
                        Generate PDF
                    </button>

                    <Link
                        to="/"
                        className="btn btn-secondary"
                    >
                        Back
                    </Link>

                </div>

            </div>

        </div>

    );
}

export default StudentDetails;